import { useMemo } from 'react';
import BarChart from '../../../../components/BarChart';
import useEmissionSpools from '../../../../hooks/web3/vault/useEmissionSpools';

const EmissionSpoolLeaderboard = () => {
    const { emissionSpools } = useEmissionSpools();

    const totalAllocAmount = useMemo(
        () =>
            emissionSpools
                ? emissionSpools.reduce(
                      (accAllocAmount, emissionSpool) =>
                          accAllocAmount + emissionSpool.allocAmount,
                      0
                  )
                : 0,
        [emissionSpools]
    );

    return (
        <div className='leaderboard'>
            {emissionSpools &&
                [...emissionSpools]
                    .sort((a, b) => {
                        const aValue = parseFloat(a['allocAmount'].toString());
                        const bValue = parseFloat(b['allocAmount'].toString());

                        return (aValue - bValue) * -1;
                    })
                    .slice(0, 10)
                    .map(({ spoolName, allocAmount }, index) => {
                        return (
                            <div key={index}>
                                <BarChart value={allocAmount} total={totalAllocAmount} />
                                <span>{spoolName}</span>
                            </div>
                        );
                    })}
        </div>
    );
};

export default EmissionSpoolLeaderboard;
